import { Import, ImportType } from 'types/domain';

const errorCount = (report: Import): number => {
    if (typeof report.error_count !== 'undefined' && report.error_count !== null) {
        return report.error_count;
    }

    const errors = report.errors;

    if (errors === undefined || errors === null) {
        return 0;
    }

    if (!Array.isArray(errors)) {
        return 0;
    }

    return errors.map(r => r.row).filter((value, index, self) => self.indexOf(value) === index)
        .length;
};

const successfulRowsCount = (report: Import) => Number(report.rows ?? 0 - errorCount(report));

const deletableImportTypes = new Set([
    'contacts',
    'companies',
    'transactions',
    'contact_activities',
    'soft_credits',
] as ImportType[]);

const isDeletableImport = (type: ImportType | Import) =>
    deletableImportTypes.has(typeof type === 'string' ? type : type.resource);

export { errorCount, successfulRowsCount, isDeletableImport };
